// removed by extract-text-webpack-plugin
module.exports = {"button":"_386T_","medium":"_1jias","text":"_2S-XM","icon":"MufoH"};


//////////////////
// WEBPACK FOOTER
// ./app/components/create-post-card/create-post-card.scss
// module id = 1522
// module chunks = 0